(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advanced-collection-filters"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('floorzy-filters')) {
  customElements.define('floorzy-filters', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) { this.mobileResultsQuery?.addEventListener('change', this.updateResults); this.updateResults?.(); return; }
      this.ready = true;
      const drawer = this.querySelector('dialog');
      const drawerForm = drawer.querySelector('form');
      const resultsButton = drawerForm.querySelector('[data-results]');
      const mobile = matchMedia('(max-width:749px)');
      const formState = () => JSON.stringify(Array.from(new FormData(drawerForm)).filter(([, value]) => String(value).trim() !== '').map(([name, value]) => [name, String(value)]).sort((a, b) => a[0].localeCompare(b[0]) || a[1].localeCompare(b[1])));
      const appliedState = formState();
      const updateResults = () => { resultsButton.disabled = mobile.matches && formState() === appliedState; };
      drawerForm.addEventListener('input', updateResults);
      drawerForm.addEventListener('change', updateResults);
      drawerForm.addEventListener('reset', () => requestAnimationFrame(updateResults));
      this.mobileResultsQuery = mobile;
      this.updateResults = updateResults;
      mobile.addEventListener('change', updateResults);
      drawerForm.addEventListener('submit', event => { if (resultsButton.disabled) event.preventDefault(); });
      updateResults();

      let opener;
      let closeTimer;
      const closeDrawer = () => {
        drawer.classList.remove('fz-is-open');
        const duration = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : parseFloat(getComputedStyle(this).getPropertyValue('--fz-duration')) || 300;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => drawer.close(), duration);
      };
      this.querySelectorAll('[data-open]').forEach(button => button.addEventListener('click', () => {
        clearTimeout(closeTimer);
        opener = button;
        const sortMode = button.dataset.open === 'sort';
        drawer.classList.toggle('fz-sort-mode', sortMode);
        updateResults();
        drawer.showModal();
        drawer.scrollTop = 0;
        drawer.getBoundingClientRect();
        drawer.classList.add('fz-is-open');
        document.documentElement.classList.add('fz-filters-lock');
        if (sortMode) drawer.querySelector('select').focus({preventScroll:true});
      }));
      this.querySelector('[data-close]').addEventListener('click', closeDrawer);
      drawer.addEventListener('cancel', event => { event.preventDefault(); closeDrawer(); });
      drawer.addEventListener('click', event => { if (event.target === drawer) { const box = drawer.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right) closeDrawer(); } });
      drawer.addEventListener('close', () => { drawer.classList.remove('fz-is-open'); document.documentElement.classList.remove('fz-filters-lock'); opener?.focus(); });
      const groups = this.querySelectorAll('.fz-filters__desktop details');
      groups.forEach(group => group.addEventListener('toggle', () => { if (group.open) groups.forEach(other => { if (other !== group) other.open = false; }); }));
      this.addEventListener('keydown', event => { if (event.key === 'Escape' && !drawer.open) groups.forEach(group => group.open = false); });
      
    }
    disconnectedCallback() { this.mobileResultsQuery?.removeEventListener('change', this.updateResults); if (this.querySelector('dialog')?.open) document.documentElement.classList.remove('fz-filters-lock'); }
  });
}

if (!window.floorzyCollectionNavigation) {
  window.floorzyCollectionNavigation = true;
  let currentRequest;
  let sequence = 0;
  let finishTimer;
  const getFilters = () => document.querySelector('floorzy-filters');
  const cleanUrl = url => { const result = new URL(url, location.href); result.searchParams.delete('sections'); result.searchParams.delete('section_id'); return result; };
  const navigate = async (destination, push = true) => {
    const filters = getFilters();
    const grid = document.getElementById('ProductGridContainer');
    const filterSection = filters?.closest('[id^="shopify-section-"]');
    const gridSection = grid?.closest('[id^="shopify-section-"]');
    const url = cleanUrl(destination);
    if (!filterSection || !gridSection) { location.assign(url.href); return; }
    currentRequest?.abort();
    const request = new AbortController();
    currentRequest = request;
    const ticket = ++sequence;
    const ids = [...new Set([filterSection.id, gridSection.id].map(id => id.replace('shopify-section-', '')))];
    const requestUrl = new URL(url);
    if (window.Shopify?.theme?.role === 'unpublished') requestUrl.searchParams.set('preview_theme_id', Shopify.theme.id);
    let line = document.querySelector('.fz-loading-line');
    if (!line) { line = document.createElement('div'); line.className = 'fz-loading-line'; line.setAttribute('aria-hidden', 'true'); document.body.append(line); }
    clearTimeout(finishTimer);
    line.style.backgroundColor = getComputedStyle(filters).getPropertyValue('--fz-accent').trim();
    line.className = 'fz-loading-line';
    line.getBoundingClientRect();
    line.classList.add('is-loading');
    grid.setAttribute('aria-busy', 'true');
    const drawer = filters.querySelector('dialog');
    if (drawer?.open) { drawer.close(); document.documentElement.classList.remove('fz-filters-lock'); }
    try {
      const parser = new DOMParser();
      const documents = await Promise.all(ids.map(async id => {
        const sectionUrl = new URL(requestUrl);
        sectionUrl.searchParams.set('section_id', id);
        const response = await fetch(sectionUrl.href, { signal: request.signal });
        if (!response.ok) throw new Error('Collection request failed');
        return parser.parseFromString(await response.text(), 'text/html');
      }));
      const freshFilters = documents[0].querySelector('floorzy-filters');
      const freshGrid = documents[ids.indexOf(gridSection.id.replace('shopify-section-', ''))].getElementById('ProductGridContainer');
      if (!freshFilters || !freshGrid) throw new Error('Incomplete collection response');
      if (ticket !== sequence) return;
      if (push && url.href !== location.href) history.pushState({ floorzyCollection: true }, '', url.href);
      grid.replaceWith(freshGrid);
      filters.replaceWith(freshFilters);
      const status = freshFilters.querySelector('.fz-filters__status');
      status?.focus({ preventScroll: true });
      const top = freshFilters.getBoundingClientRect().top;
      if (top < 0 || top > innerHeight * .7) freshFilters.scrollIntoView({ block: 'start', behavior: 'instant' });
      document.dispatchEvent(new CustomEvent('floorzy:collection:updated', { detail: { url: url.href } }));
    } catch (error) {
      if (error.name !== 'AbortError' && ticket === sequence) { console.warn('Collection background update unavailable:', error.message); location.assign(url.href); }
    } finally {
      if (ticket === sequence) {
        document.getElementById('ProductGridContainer')?.removeAttribute('aria-busy');
        line.className = 'fz-loading-line is-complete';
        finishTimer = setTimeout(() => { line.className = 'fz-loading-line'; }, 250);
      }
    }
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('floorzy-filters') || event.defaultPrevented) return;
    event.preventDefault();
    const url = cleanUrl(location.href);
    url.pathname = new URL(form.action, location.href).pathname;
    for (const name of [...url.searchParams.keys()]) if (name.startsWith('filter.') || name === 'sort_by' || name === 'page') url.searchParams.delete(name);
    for (const [name, value] of new FormData(form)) if (String(value).trim() !== '') url.searchParams.append(name, value);
    navigate(url);
  });
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.target || link.hasAttribute('download')) return;
    const filters = getFilters();
    const withinFilters = filters?.contains(link);
    const pagination = link.closest('#ProductGridContainer .pagination-wrapper, #ProductGridContainer .pagination');
    if (!withinFilters && !pagination) return;
    const url = cleanUrl(link.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    navigate(url);
  }, true);
  window.addEventListener('popstate', () => { if (getFilters()) navigate(location.href, false); });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fe-announcement-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fe-announcement')) {
  customElements.define('fe-announcement', class extends HTMLElement {
    connectedCallback() {
      this.update = () => {
        const section = this.closest('.shopify-section');
        const sticky = section && getComputedStyle(section).position === 'sticky' && section.getBoundingClientRect().height > 0;
        document.documentElement.style.setProperty('--fe-announcement-offset', sticky ? section.getBoundingClientRect().height + 'px' : '0px');
      };
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this);
      window.addEventListener('resize', this.update);
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('resize', this.update);
      document.documentElement.style.removeProperty('--fe-announcement-offset');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  if (!customElements.get('fe-collection-description')) {
    customElements.define('fe-collection-description', class extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('.fe-description__content');
        this.viewport = this.querySelector('.fe-description__viewport');
        this.button = this.querySelector('button');
        this.expanded = false;
        this.savedTabIndexes = new Map();
        this.onClick = () => {
          this.expanded = !this.expanded;
          this.render();
          if (!this.expanded && this.getBoundingClientRect().top < 0) this.scrollIntoView({block: 'start', behavior: 'instant'});
        };
        this.button.addEventListener('click', this.onClick);
        this.observer = new ResizeObserver(() => this.schedule());
        this.observer.observe(this.content);
        this.schedule();
        if (document.fonts) document.fonts.ready.then(() => { if (this.isConnected) this.schedule(); });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.button?.removeEventListener('click', this.onClick);
        this.restoreLinks();
      }
      schedule() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.measure());
      }
      measure() {
        const bounds = this.content.getBoundingClientRect();
        if (!bounds.width) return;
        const rows = [];
        const walker = document.createTreeWalker(this.content, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          if (!node.textContent.trim()) continue;
          const range = document.createRange();
          range.selectNodeContents(node);
          for (const rect of range.getClientRects()) {
            if (rect.width < 1 || rect.height < 1) continue;
            const row = rows.find(item => Math.abs(item.top - rect.top) < 4);
            if (row) row.bottom = Math.max(row.bottom, rect.bottom);
            else rows.push({top: rect.top, bottom: rect.bottom, lineHeight: parseFloat(getComputedStyle(node.parentElement).lineHeight) || rect.height});
          }
        }
        rows.sort((a, b) => a.top - b.top);
        const limit = Math.max(1, Number(this.dataset.lines) || 3);
        const last = rows[limit - 1];
        this.overflows = rows.length > limit;
        if (last && this.overflows) {
          this.cutoff = Math.ceil(last.bottom - bounds.top + Math.max(0, (last.lineHeight - (last.bottom - last.top)) / 2));
          this.style.setProperty('--fe-description-height', this.cutoff + 'px');
          this.style.setProperty('--fe-description-fade', Math.ceil(this.cutoff - (last.top - bounds.top)) + 'px');
        }
        this.render();
      }
      restoreLinks() {
        this.savedTabIndexes?.forEach((value, link) => value === null ? link.removeAttribute('tabindex') : link.setAttribute('tabindex', value));
        this.savedTabIndexes?.clear();
      }
      render() {
        const collapsed = this.overflows && !this.expanded;
        this.toggleAttribute('data-collapsed', collapsed);
        this.button.hidden = !this.overflows;
        this.button.setAttribute('aria-expanded', String(!collapsed));
        this.querySelector('[data-more]').hidden = !collapsed;
        this.querySelector('[data-less]').hidden = collapsed;
        this.restoreLinks();
        if (collapsed) {
          const top = this.content.getBoundingClientRect().top;
          this.content.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(link => {
            if (link.getBoundingClientRect().bottom > top + this.cutoff) {
              this.savedTabIndexes.set(link, link.getAttribute('tabindex'));
              link.setAttribute('tabindex', '-1');
            }
          });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
